(() => {
  const STORAGE_KEY = 'cropcrates_recent_handles_v1';
  const MAX_STORED = 8;

  let privacyReady = false;

  function getItems() {
    try {
      const items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');

      if (!Array.isArray(items)) return [];

      return [...new Set(items.filter(Boolean))];
    } catch (error) {
      return [];
    }
  }

  function saveItems(items) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify([...new Set(items)].slice(0, MAX_STORED))
      );
    } catch (error) {
      console.warn('Cropcrates recently viewed storage unavailable.');
    }
  }

  function clearItems() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {}
  }

  function preferencesAllowed() {
    return Boolean(
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      window.Shopify.customerPrivacy.preferencesProcessingAllowed()
    );
  }

  function trackCurrentProduct() {
    if (!preferencesAllowed()) return;

    const current = window.CropcratesCurrentProduct;

    if (!current || !current.handle) return;

    let items = getItems();

    items = items.filter(handle => handle !== current.handle);
    items.unshift(current.handle);

    saveItems(items);
  }

  function formatMoney(cents, currency) {
    const value = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'en-US',
        {
          style: 'currency',
          currency: currency || 'USD'
        }
      ).format(value);
    } catch (error) {
      return `$${value.toFixed(2)}`;
    }
  }

  function buildImageUrl(url, width = 1200) {
    if (!url) return '';

    try {
      const imageUrl = new URL(url, window.location.origin);
      imageUrl.searchParams.set('width', width);
      return imageUrl.toString();
    } catch (error) {
      return url;
    }
  }

  function createCard(product, currency, showVendor) {
    const card = document.createElement('article');
    card.className = 'cc-recent-card';

    const link = document.createElement('a');
    link.className = 'cc-recent-card__link';
    link.href = product.url || `/products/${product.handle}`;

    const media = document.createElement('div');
    media.className = 'cc-recent-card__media';

    if (product.featured_image) {
      const image = document.createElement('img');

      image.className = 'cc-recent-card__image';
      image.src = buildImageUrl(product.featured_image);
      image.alt = product.title || '';
      image.loading = 'lazy';

      media.appendChild(image);
    }

    const information = document.createElement('div');
    information.className = 'cc-recent-card__information';

    if (showVendor && product.vendor) {
      const vendor = document.createElement('div');
      vendor.className = 'cc-recent-card__vendor';
      vendor.textContent = product.vendor;
      information.appendChild(vendor);
    }

    const title = document.createElement('div');
    title.className = 'cc-recent-card__title';
    title.textContent = product.title;

    const prices = document.createElement('div');
    prices.className = 'cc-recent-card__prices';

    const price = document.createElement('span');
    price.className = 'cc-recent-card__price';
    price.textContent = formatMoney(product.price, currency);

    prices.appendChild(price);

    if (
      product.compare_at_price &&
      Number(product.compare_at_price) > Number(product.price)
    ) {
      const compare = document.createElement('s');
      compare.className = 'cc-recent-card__compare-price';
      compare.textContent = formatMoney(
        product.compare_at_price,
        currency
      );

      prices.appendChild(compare);
    }

    information.appendChild(title);
    information.appendChild(prices);

    link.appendChild(media);
    link.appendChild(information);

    card.appendChild(link);

    return card;
  }

  async function renderSection(section) {
    if (!privacyReady || !preferencesAllowed()) {
      section.hidden = true;
      return;
    }

    const currentHandle =
      window.CropcratesCurrentProduct?.handle || '';

    const limit = Number(section.dataset.limit || 4);
    const currency = section.dataset.currency || 'USD';
    const showVendor = section.dataset.showVendor === 'true';

    const handles = getItems()
      .filter(handle => handle !== currentHandle)
      .slice(0, limit);

    const grid = section.querySelector('[data-recent-grid]');

    if (!handles.length || !grid) {
      section.hidden = true;
      return;
    }

    const root = window.Shopify?.routes?.root || '/';

    const requests = handles.map(async handle => {
      const response = await fetch(
        `${root}products/${encodeURIComponent(handle)}.js`,
        {
          headers: {
            Accept: 'application/json'
          }
        }
      );

      if (!response.ok) {
        throw new Error(`Unable to load ${handle}`);
      }

      return response.json();
    });

    const results = await Promise.allSettled(requests);

    grid.innerHTML = '';

    results.forEach(result => {
      if (result.status !== 'fulfilled') return;

      grid.appendChild(
        createCard(result.value, currency, showVendor)
      );
    });

    section.hidden = grid.children.length === 0;
  }

  function renderAllSections() {
    document
      .querySelectorAll('[data-cropcrates-recently-viewed]')
      .forEach(renderSection);
  }

  function initializeAllowedState() {
    if (!preferencesAllowed()) {
      clearItems();
      renderAllSections();
      return;
    }

    trackCurrentProduct();
    renderAllSections();
  }

  function initializePrivacy() {
    if (
      !window.Shopify ||
      typeof window.Shopify.loadFeatures !== 'function'
    ) {
      return;
    }

    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1'
        }
      ],
      error => {
        if (error) return;

        privacyReady = true;
        initializeAllowedState();
      }
    );
  }

  document.addEventListener(
    'visitorConsentCollected',
    event => {
      if (!privacyReady) return;

      if (event.detail?.preferencesAllowed) {
        trackCurrentProduct();
      } else {
        clearItems();
      }

      renderAllSections();
    }
  );

  document.addEventListener(
    'shopify:section:load',
    renderAllSections
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializePrivacy
    );
  } else {
    initializePrivacy();
  }
})();